var e = function() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : null;
};
export {
  e as getGlobal
};
//# sourceMappingURL=index21.js.map
